const s = {
  name: "CurrencyEgyptianPoundV2",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M23,16c0-1.7,1.3-3,3-3s3,1.3,3,3h2c0-2.8-2.2-5-5-5s-5,2.2-5,5v3h-2v2h2v8h10v-2h-8v-6h5v-2h-5V16z"/>
		<path class="st0" d="M9,11h10v2h-8v6h6v2h-6v6h8v2H9V11z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31.1,0,20,0z M2,20c0-9.9,8.1-18,18-18c9.9,0,18,8.1,18,18
			s-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CurrencyEgyptianPoundV2
};
